export default "__VITE_ASSET__87f5cbee__"